var map = {
	"./google-play-badge-da.png": "c507",
	"./google-play-badge-de.png": "b6a6",
	"./google-play-badge-en.png": "87d8",
	"./google-play-badge-es.png": "b8ac",
	"./google-play-badge-fi.png": "adff",
	"./google-play-badge-fr.png": "e0a0",
	"./google-play-badge-it.png": "d812",
	"./google-play-badge-nb.png": "1523",
	"./google-play-badge-nl.png": "c510",
	"./google-play-badge-pl.png": "6d5d",
	"./google-play-badge-pt.png": "65c9",
	"./google-play-badge-sv.png": "bdd7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c7f";